<!-- Template -->
<div class="ui-g component-container" *ngIf="((technicianData && applicationStatus === 'active') || isCustomer) && productsConfiguration">
  <ng-container *ngFor="let item of installationItems">
    <div
      tabindex="0"
      class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-6 ui-xs-6 tiles-padding"
      [attr.id]="item.id"
      *ngIf="productsConfiguration[item.configKey]?.show">
      <div class="pointer-cursor" [class.tile-disabled]="item.isDisabled" (click)="selectProduct(item.id)">
        <div class="placeholder-tiles">
          <div class="placeholder-img">
            <img [alt]="item.altText" [src]="'assets/images/' + item.icon" />
          </div>
          <div class="placeholder-label">{{ item.translationKey | translate }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="ui-g component-container" *ngIf="applicationStatus === 'noaccess' || applicationStatus === 'waitingForApproval'">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <h4 class="margin-header-align text-message-align">{{ 'installation-data.license-under-review-message' | translate }}</h4>
  </div>
</div>

<div class="ui-g component-container" *ngIf="applicationStatus === 'expired'">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <h4 class="margin-header-align text-message-align">{{ 'installation-data.license-expired-message' | translate }}</h4>
  </div>
</div>

<div class="ui-g component-container" *ngIf="applicationStatus === 'newRegistrationSubmitted'">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <h4 class="margin-header-align text-message-align">{{ 'waiting for approval' | translate }}</h4>
  </div>
</div>

<app-loader *ngIf="isLoading"></app-loader>

<p-confirmDialog
  key="new-app-confirm"
  data-testId="new-app-confirm"
  #confirmDialog
  icon="pi pi-info-circle"
  message="{{ 'basic-profile.jurisdiction.new-application-confirm-text' | translate }}"
  styleClass="netz-confirm-dialog">
  <p-footer>
    <button (click)="confirmDialog.accept()" label="{{ 'yes-button-label' | translate }}" pButton type="button"></button>
    <button (click)="confirmDialog.reject()" label="{{ 'no-button-label' | translate }}" pButton type="button"></button>
  </p-footer>
</p-confirmDialog>
